import type { Ref } from 'vue';
import type { BlockSerialized, BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/types/block';
import { computed } from 'vue';
import { isBlockSerializedChild } from '#layers/block-engine/utils/block/editor';

export function useBlockEditorChildParentMap({
	blockData,
}: {
	blockData: Ref<BlockSerialized | null>;
}) {
	/**
	 * Child id => parent child id and slot name
	 */
	const childParentMap = computed(() => {
		const parentMap = new Map<string, { parentId: string; slot: string }>();

		for (const childId in blockData.value?.children ?? {}) {
			const child = blockData.value!.children![childId]!;

			if (isBlockSerializedChild(child)) {
				for (const slot in child.slots) {
					for (const childId of child.slots[slot]!) {
						parentMap.set(childId, { parentId: child.id, slot });
					}
				}
			}
		}

		return parentMap;
	});

	function getParent(childId: string): BlockSerializedChild | BlockSerializedSlotOutlet | undefined {
		const parent = childParentMap.value.get(childId);
		if (!parent) return undefined;

		return blockData.value?.children?.[parent.parentId];
	}

	return {
		childParentMap,
		getParent,
	};
}

export type BlockEditorChildParentMap = ReturnType<typeof useBlockEditorChildParentMap>['childParentMap'];
export type BlockEditorGetParent = ReturnType<typeof useBlockEditorChildParentMap>['getParent'];
